
export default {
	USPS_userId: '101BATES1282',
}